module.exports = __webpack_public_path__ + "static/media/logo_vpbank.c8714577.svg";